"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sessionResponseSchema = exports.leadCardDataSchema = exports.pendingCardsSchema = exports.pendingCardEntrySchema = exports.createSessionSchema = exports.widgetConfigSchema = exports.widgetDigitalAssetSchema = exports.widgetFaqSchema = exports.widgetQuickQuestionSchema = void 0;
const zod_1 = require("zod");
exports.widgetQuickQuestionSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    text: zod_1.z.string(),
    i18n: zod_1.z.record(zod_1.z.string(), zod_1.z.string()).optional(),
});
exports.widgetFaqSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    question: zod_1.z.string(),
    answer: zod_1.z.string(),
    i18n: zod_1.z
        .record(zod_1.z.string(), zod_1.z.object({ question: zod_1.z.string(), answer: zod_1.z.string() }))
        .optional(),
});
exports.widgetDigitalAssetSchema = zod_1.z.object({
    state: zod_1.z.enum(['idle', 'speaking', 'listening', 'greeting']),
    videoUrl: zod_1.z.string().url(), // OBS 签名 GET URL,1h 有效 (spec §5.6)
    posterUrl: zod_1.z.string().url().nullable().optional(),
    durationMs: zod_1.z.number().int(),
});
exports.widgetConfigSchema = zod_1.z.object({
    clientId: zod_1.z.string().uuid(),
    siteId: zod_1.z.string().uuid(),
    merchantId: zod_1.z.string().uuid(),
    type: zod_1.z.enum(['web', 'digital']),
    theme: zod_1.z.string(),
    titleBgGradient: zod_1.z.string().nullable(),
    name: zod_1.z.string(),
    avatarUrl: zod_1.z.string().url().nullable(), // 签名 GET URL
    welcomeMsg: zod_1.z.string(),
    guideMsg: zod_1.z.string().nullable(),
    fallbackMsg: zod_1.z.string().nullable(),
    // 人工客服招呼语:转人工接通后由 widget 主动展示,引导访客(对标 welcomeMsg;BE build 时 ?? '' 保证非空,空则前端回退内置文案)
    humanWelcomeMsg: zod_1.z.string(),
    // 客服文案多语言译文 { locale: { fieldName: 译文 } }; 切语言时按 [locale][fieldName] 取,fallback 到源字段
    i18n: zod_1.z.record(zod_1.z.string(), zod_1.z.record(zod_1.z.string(), zod_1.z.string())).optional(),
    defaultWindow: zod_1.z.enum(['min', 'max']),
    showButton: zod_1.z.boolean(),
    // ── widget 位置 / 外部唤起（BE build() 永远投影；旧客户端忽略多余字段，CSS 兜底 24px）──
    buttonPosition: zod_1.z.enum(['left', 'right']), // 迷你按钮靠左/靠右
    offsetUnit: zod_1.z.enum(['px', 'percent']), // 偏移单位(X/Y共用): percent 时水平vw/垂直vh
    offsetX: zod_1.z.number().int(), // 水平偏移(靠左=距左,靠右=距右)
    offsetY: zod_1.z.number().int(), // 垂直偏移(距底部)
    invokeEventName: zod_1.z.string(), // 外部唤起 window 自定义事件名(默认 dcs:widget:open)
    wechatQrUrl: zod_1.z.string().url().nullable(),
    workTime: zod_1.z.string().nullable(),
    allowedDomains: zod_1.z.array(zod_1.z.string()),
    quickQuestions: zod_1.z.array(exports.widgetQuickQuestionSchema),
    faqs: zod_1.z.array(exports.widgetFaqSchema),
    digitalHumanAssets: zod_1.z.array(exports.widgetDigitalAssetSchema),
    // type=digital 且后端启用实时 TTS 时为 true:widget 等 ai.audio 驱动「音频+打字机」回显;
    // 缺省/false:数字人按 web 式实时流式回显 AI 文本(无语音,无等待)。仅 digital 有意义。
    audioEnabled: zod_1.z.boolean().optional(),
    wsUrl: zod_1.z.string(),
    apiBase: zod_1.z.string(),
    widgetBundleUrl: zod_1.z.string(),
    // 私有桶后弃用,所有资源走签名 URL,字段保留为空字符串以兼容现有客户端
    assetBase: zod_1.z.string(),
    // 人工 IM(vocechat 访客 SDK)对接配置。type=web 与 digital 且 enabled 时,widget 走 vocechat
    // 访客链路(浏览器直连 baseUrl,见 docs);缺省/未启用时维持现有自家 AI 客服链路。
    // baseUrl 例: https://api-test.iwanshang.cloud/im3/api (访客 SDK REST 根)
    im: zod_1.z
        .object({
        baseUrl: zod_1.z.string(),
        enabled: zod_1.z.boolean(),
    })
        .optional(),
});
exports.createSessionSchema = zod_1.z.object({
    clientId: zod_1.z.string().uuid(),
    fingerprint: zod_1.z.string().min(1).max(64),
    locale: zod_1.z.string().min(2).max(16).default('zh'),
    /** 访客发起会话所在的宿主页 URL（widget 注入宿主同文档，取 location.href；推送主站 sourceUrl） */
    pageUrl: zod_1.z.string().url().max(2048).optional(),
});
/**
 * 会话级"待办卡"通用容器(lead / ticket / 其它)。kind 由业务侧自定义,
 * 前端按 kind 分发渲染。提交成功 / reset 后 BE 删除对应 kind(整字段空则置 null)。
 * dismissed=true → 渲染为可点 pill 入口(留资卡: lead-reopen);false → 直接弹卡。
 */
exports.pendingCardEntrySchema = zod_1.z.object({
    /** kind 特定的展示参数(留资卡: { fields, prompt };工单卡 TBD) */
    data: zod_1.z.unknown(),
    dismissed: zod_1.z.boolean(),
});
exports.pendingCardsSchema = zod_1.z.record(zod_1.z.string(), exports.pendingCardEntrySchema);
/** 留资卡的 data 字段载荷(前端 type narrow 用) */
exports.leadCardDataSchema = zod_1.z.object({
    fields: zod_1.z.array(zod_1.z.enum(['name', 'phone', 'wechat', 'email'])),
    prompt: zod_1.z.string(),
    /** 触发该卡片的 AI 回答消息 id,用于刷新/重连还原后仍锚定在原回答下方 */
    messageId: zod_1.z.string().optional(),
});
exports.sessionResponseSchema = zod_1.z.object({
    visitorToken: zod_1.z.string(),
    convId: zod_1.z.string().uuid(),
    history: zod_1.z.array(zod_1.z.unknown()), // Message[],按 conversation pipeline 落地
    welcomeMsg: zod_1.z.string(),
    quickQuestions: zod_1.z.array(exports.widgetQuickQuestionSchema),
    /** 会话级待办卡快照(无则 null);按 kind 取,例如 pendingCards?.lead */
    pendingCards: exports.pendingCardsSchema.nullable().optional(),
    /**
     * 在飞回合快照(无则 null):刷新 / 重连时 FE 据此恢复忙碌闸门并续传流式气泡。
     * messageId 为 null 表示回合尚在前置阶段(意图分类等),text 为已推流文本快照。
     */
    activeTurn: zod_1.z
        .object({ messageId: zod_1.z.string().nullable(), text: zod_1.z.string() })
        .nullable()
        .optional(),
});
//# sourceMappingURL=widget.js.map